/// <reference path="Assistant.ts" />


namespace TerminalApp {
    export class PicklistProblemAssistant extends Assistant {
        action_menu = document.createElement("div");
        order_info_container = document.createElement("div");
        action_container = document.createElement("div");
        quantity_menu = document.createElement("div");
        quantity_container = document.createElement("div");
        finish_menu = document.createElement("div");
        finish_container = document.createElement("div");

        placement_menu = document.createElement("div");
        placement_container = document.createElement("div");

        attention_list_button: HTMLElement;
        remove_item_button: HTMLElement;
        audit_item_button: HTMLElement;
        change_pick_placement_button: HTMLElement;
        line: SP.PickListLineData;
        list: SP.PickListInfo;
        location: string;
        remove_item_quantity = 0;
        remove_item_quantity_input: HTMLInputElement;

        change_quantity = 0;
        change_quantity_input: HTMLInputElement;
        callback: () => void;
        constructor() {
            super();

            this.finish_menu.innerHTML = `<h1>${SP.Localize("sentance_item_has_been_removed")}</h1>
                <div class='info'>
                    ${SP.Localize("description_return_or_audit_1")}<br /> <span class='return_location'></span><br />
                    ${SP.Localize("description_return_or_audit_2")}
                </div>

            `;
            this.finish_menu.append(this.finish_container);

            this.action_menu.innerHTML = `<h1>${SP.Localize("word_problem")}</h1>`; 
            this.action_menu.append(this.action_container);
            this.action_menu.append(this.order_info_container);

            this.order_info_container.classList.add("oid");
            this.order_info_container.innerHTML = `
               
                <div class="oid_info simple-scroll">
                    <h1>${SP.Localize("sentance_order_info")}</h1>
                    <div class="box oid_order_data"></div>
                    <div class="box">
                        <b style="color:#fff">${SP.Localize("word_recipient")}:</b>
                        <div class="oid_recipient"></div>
                    </div>
                    <h2>${SP.Localize("word_items")}</h2>
                    <div class="oid_items">...</div>
                </div>
            `;

  
            this.attention_list_button = this.addItem(this.action_container, SP.Localize("sentance_move_to_attention_list"), SP.Localize("sentance_the_problem_will_be_resloved_later"), "fa-solid fa-calendar-clock", "black",  async () => {
                //Move action!
                await App_Picklist.instance.removeShipment(this.line.pickLineInfo.shipmentId);
                this.close();
            });

            this.remove_item_button = this.addItem(this.action_container, SP.Localize("sentance_remove_item"), SP.Localize("description_remove_item"), "fa-solid fa-trash-list", "black", async () => {
                //Move action!
                this.open_quantity_picker();
            });
            this.audit_item_button = this.addItem(this.action_container, SP.Localize("sentance_audit_item"), SP.Localize("description_audit_item"), "fa-solid fa-calculator", "black", async () => {
                //setTimeout(() => {
                SP.setAllHash({ "app": "app_audit_stock", "customerId": this.line.stockingLotInfo.item.customerId, "itemId": this.line.stockingLotInfo.item.id });
                //}, 300);
                this.close();
            });

            this.change_pick_placement_button = this.addItem(this.action_container, SP.Localize("sentance_change_pick_placement"), SP.Localize("description_change_pick_placement"), "fa-solid fa-shelves", "black", async () => {
                //Open pick placement changer
                this.open_placement_picker();
            });


            var audit_item_button2 = this.addItem(this.finish_container, SP.Localize("sentance_audit_item"), "", "fa-solid fa-calculator", "black", async () => {
                setTimeout(() => {
                    SP.setAllHash({ "app": "app_audit_stock", "customerId": this.line.stockingLotInfo.item.customerId, "itemId": this.line.stockingLotInfo.item.id });
                }, 300);
                this.close();
            });

            var finish_button = this.addItem(this.finish_container, SP.Localize("word_finish"), "", "fa-solid fa-check", "black", async () => {
                this.close();
            });



            this.placement_menu.innerHTML = `
            <h1>${SP.Localize("sentance_select_quantity")}</h1>
            <div class="qty_picker">
            <div class="button minus grad-gray" bis_skin_checked="1"><i class="fas fa-minus" aria-hidden="true"></i></div>
            <div class="input_box" bis_skin_checked="1"><input type="number" value="0"> / <span class='max_quantity'>0</span></div>
            <div class="button plus grad-gray" bis_skin_checked="1"><i class="fas fa-plus" aria-hidden="true"></i></div>
            </div>
            <h1>${SP.Localize("sentance_select_new_placement")}</h1>
            <div class="setting_group">
            </div>
            `;

            this.placement_container = this.placement_menu.querySelector(".setting_group");

            var change_qty_input = this.change_quantity_input = this.placement_menu.querySelector("input");
            change_qty_input.addEventListener("focus", () => { change_qty_input.select() });
            change_qty_input.addEventListener("change", () => {
                var old = this.change_quantity;
                this.change_quantity = Math.max(1, Math.min(this.line.pickLineInfo.quantity, parseInt(change_qty_input.value)));
                if (isNaN(this.change_quantity)) this.change_quantity = old;

                change_qty_input.value = this.change_quantity.toString();
            });

            this.placement_menu.querySelector(".button.plus").addEventListener("click", () => {
                this.change_quantity = Math.min(this.line.pickLineInfo.quantity, parseInt(change_qty_input.value) + 1);
                change_qty_input.value = this.change_quantity.toString();
            });

            this.placement_menu.querySelector(".button.minus").addEventListener("click", () => {
                this.change_quantity = Math.max(1, parseInt(change_qty_input.value) - 1);
                change_qty_input.value = this.change_quantity.toString();
            });





            this.quantity_menu.innerHTML = `
            <h1>${SP.Localize("sentance_remove_quantity")}</h1>
            <div class="qty_picker">
            <div class="button minus grad-gray" bis_skin_checked="1"><i class="fas fa-minus" aria-hidden="true"></i></div>
            <div class="input_box" bis_skin_checked="1"><input type="number" value="0"> / <span class='max_quantity'>0</span></div>
            <div class="button plus grad-gray" bis_skin_checked="1"><i class="fas fa-plus" aria-hidden="true"></i></div>
            </div>
            `;

            var remove_qty_input = this.remove_item_quantity_input = this.quantity_menu.querySelector("input");
            remove_qty_input.addEventListener("focus", () => { remove_qty_input.select() });
            remove_qty_input.addEventListener("change", () => {
                var old = this.remove_item_quantity;
                this.remove_item_quantity = Math.max(1, Math.min(this.line.pickLineInfo.quantity, parseInt(remove_qty_input.value)));
                if (isNaN(this.remove_item_quantity)) this.remove_item_quantity = old;

                remove_qty_input.value = this.remove_item_quantity.toString();
            });

            this.quantity_menu.querySelector(".button.plus").addEventListener("click", () => {
                this.remove_item_quantity = Math.min(this.line.pickLineInfo.quantity, parseInt(remove_qty_input.value) + 1);
                remove_qty_input.value = this.remove_item_quantity.toString();
            });

            this.quantity_menu.querySelector(".button.minus").addEventListener("click", () => {
                this.remove_item_quantity = Math.max(1, parseInt(remove_qty_input.value) - 1);
                remove_qty_input.value = this.remove_item_quantity.toString();
            });


            this.quantity_menu.append(this.quantity_container);


            this.container.appendChild(this.action_menu);
            this.container.appendChild(this.placement_menu);
            this.container.appendChild(this.quantity_menu);
            this.container.appendChild(this.finish_menu);




            this.addItem(this.quantity_container, SP.Localize("sentance_dont_send_later"), SP.Localize("description_dont_send_later"), "fa-solid fa-trash-can", "black", async () => {
                var success = await App_Picklist.instance.removeLine(this.line.pickLineInfo.id, this.remove_item_quantity, true);
                if (success) { 
                    this.open_finish();
                }
            });

            this.addItem(this.quantity_container, SP.Localize("sentance_send_later"), SP.Localize("description_send_later"), "fa-solid fa-truck-clock", "black", async () => {
                var success = await App_Picklist.instance.removeLine(this.line.pickLineInfo.id, this.remove_item_quantity, false);
                if (success) {
                    this.open_finish();
                }
            });


        }

        close() {
            super.close();
            if (this.callback != null) {
                this.callback();
                this.callback = null;
            }
        }

        hide() {
            this.action_menu.style.display = "none";
            this.quantity_menu.style.display = "none";
            this.finish_menu.style.display = "none";
            this.placement_menu.style.display = "none";
        }

        open_action() {
            this.hide();
            this.container.style.display = "block";
            this.action_menu.style.display = "block";
        }

        open_quantity_picker() {
            this.hide();
            this.container.style.display = "block";
            this.quantity_menu.style.display = "block";

            this.remove_item_quantity = this.line.pickLineInfo.quantity - this.line.pickLineInfo.pickedQuantity;
            this.remove_item_quantity_input.value = this.remove_item_quantity.toString();
            this.quantity_menu.querySelector(".max_quantity").innerHTML = this.line.pickLineInfo.quantity.toString();

        }

        async open_placement_picker() {
            this.hide();
            this.container.style.display = "block";
            this.placement_menu.style.display = "block";
            this.placement_container.innerHTML = "";

            this.change_quantity = this.line.pickLineInfo.quantity;
            this.change_quantity_input.value = this.change_quantity.toString();
            this.placement_menu.querySelector(".max_quantity").innerHTML = this.line.pickLineInfo.quantity.toString();
            var lots = await SP.Data.StockingLot.getItemStockingLotInfos(this.line.stockingLotInfo.item.id);


            
            let c = 0;
            //console.log(lots);
            lots.forEach(l => {
                if (l.id != this.line.stockingLotInfo.id) {
                    c++;
                    var pi = new PlacementInfoBox(l.stockPlacementData, true, l.item, l.placementQuantity);
                    let cont = document.createElement("div");
                    cont.classList.add("audit_zone_placement");
                    cont.appendChild(pi.container);
                    this.placement_container.appendChild(cont);

                    if (l.batchNumber) {
                        var batch = document.createElement("div");
                        batch.classList.add("batchNumber");
                        batch.innerHTML = "BATCH: " + l.batchNumber;
                        cont.appendChild(batch);
                    }

                    cont.addEventListener("click", async () => {
                        StartLoading();
                        try {
                            var success = await App_Picklist.instance.changeLine(this.line.pickLineInfo.id, this.change_quantity, l.id);
                            if (success) {
                                this.close();
                                await SP.sleep(200);
                                location.reload(); //reload to update list
                            }
                        } finally {
                            StopLoading();
                        }

                    });

                }
            });

            if (c == 0) {
                let cont = document.createElement("div");
                cont.classList.add("audit_zone_placement");
                cont.innerHTML = "No placements found!";
                this.placement_container.appendChild(cont);
            }

        }

        open_finish() {
            this.hide();
            this.container.style.display = "block";
            this.finish_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.action_container.innerHTML = "";
            this.container.style.display = "none";
        }

        async open(line: SP.PickListLineData, list: SP.PickListInfo, location:string, callback: () => void) {
            this.line = line;
            this.list = list;
            this.location = location;
            this.callback = callback;
            this.open_action();
       


   

            this.finish_menu.querySelector(".return_location").innerHTML = location;

            var shipment = await SP.Data.Shipment.getShipmentInfo(line.pickLineInfo.shipmentId);

            this.order_info_container.querySelector(".oid_order_data").innerHTML =
                "<b style='color: #fff'>OrderNo: " + shipment.order.orderNo + "</b> <br />" +
            "<b>ReferenceNo:</b> " + shipment.order.referenceNo + "<br />" +
            "<b>DeliveryMethod:</b> " + shipment.order.deliveryMethodInfo.name + " (" + shipment.order.deliveryMethodInfo.shortName + ")<br />";

            this.order_info_container.querySelector(".oid_recipient").innerHTML =
                shipment.order.recipient.name + "<br />" +
            (shipment.order.recipient.attention ? shipment.order.recipient.attention + "<br />" : "") +
            shipment.order.recipient.street1 + "<br />" +
            (shipment.order.recipient.street2 ? shipment.order.recipient.street2 + "<br />" : "") +
            shipment.order.recipient.zipcode + " " + shipment.order.recipient.city + ", " + shipment.order.recipient.country + "<br />" +
            shipment.order.recipient.email + " / " + shipment.order.recipient.phone;

            var items = this.order_info_container.querySelector(".oid_items");

            //clear
            items.innerHTML = "";

            for (let i = 0; i < shipment.lines.length; i++) {
                let line = shipment.lines[i];
                let name = line.orderLine.itemInfo.sku + " - " + line.orderLine.itemInfo.manufacturerName + " " + line.orderLine.itemInfo.modelNo;
                items.innerHTML +=
                    "<div class='box item'>" +
                    (line.id == this.line.pickLineInfo.orderLineId ? "<i class='warning fa-solid fa-circle-exclamation'></i>" : "") +
                "<img src='" + line.orderLine.itemInfo.imageUrl + "'> " +
                "<span class='details'> <b style='color: #fff'>" + name + "</b><br /><small>" + line.orderLine.itemInfo.description + "<br /><b>" + line.orderLine.itemInfo.barcodes.join(", ") + "</b></small><span>" +
                "<span class='qty'><b style='color: #fff'>" + line.qty + " " + line.orderLine.itemInfo.unitType + "</b></span>"
                "</div>";
            }

            this.attention_list_button.style.display = list.pickListAttention ? "none" : "block";
        }

        addItem(container: HTMLElement, title: string, descrpition: string, icon:string, color:string, action: () => void) {
            var c = document.createElement("div");
            c.classList.add("btn", "noselect");
            if (icon) {
                c.innerHTML = `<div class='icon fa' style='color:${color}'><i class="${icon}"></i></div>`;
            }
            c.innerHTML += `<div class='action'>${title}</div>${descrpition}`;
            c.addEventListener("click", () => {
                action();
            });
            container.appendChild(c);
            return c;
        }
    }
}